module.exports = __webpack_public_path__ + "8fb7623c6ee458c2270a8210b24cce91.png";